import Application from "./application"
import Overlay from "./overlay"
import { getQueryStringVariable } from './utilities/index';

if (__DEV__) {
	console.log("DEVELOPMENT ENVIRONMENT")
}
if (__SRC__) {
	console.log("SOURCE ENVIRONMENT")
}
if (__DIST__) {
	console.log("DISTRIBUTION ENVIRONMENT")
}

window.driverSelector = new Application()

const IdleManager = {
	timeoutDuration: 120000, // 2 min
	timer: null,

	init() {
		// Bind events to reset the timer
		const events = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];

		events.forEach(event => {
			window.addEventListener(event, () => this.resetTimer());
		});

		this.startTimer();
		console.log("Inactivity tracker initialized.");
	},

	startTimer() {
		this.timer = setTimeout(() => this.onIdle(), this.timeoutDuration);
	},

	resetTimer() {
		clearTimeout(this.timer);
		this.startTimer();
	},

	onIdle() {
		console.log("User is idle. Executing function...");
		window.driverSelector.restart();
		this.resetTimer();
	},

};

//Enable timeout for partner sites
if (getQueryStringVariable('partner') === "true") {
	IdleManager.init();
}
// /**
//  * IFRAME RESIZING
//  */
function resizeFrame() {
	requestAnimationFrame(function () {
		// let height = 770;
		let height = window.driverSelector.getHeight()

		window.parent.postMessage(["frameHeight", height], "*")
	})
}
window.resizeFrame = resizeFrame
resizeFrame()
window.addEventListener("load", resizeFrame)
window.addEventListener("resize", resizeFrame)

window.showResultsError = function () {
	let overlay = new Overlay()
	overlay.showResultsError()
}
window.showResultsSuccess = function () {
	let overlay = new Overlay()
	overlay.showResultsSuccess()
}

/***
 *
 * TODO: If logged in to Team Titleist call this function to prepopulate the email field:
 * window.setInitialEmailValue('tom@sample.com');
 *
 */
window.setInitialEmailValue = function (email) {
	console.log("window.setInitialEmailValue: " + email)
	let overlay = new Overlay()
	overlay.setInitialEmailValue(email)
}
// window.setInitialEmailValue('tom@sample.com');

/***
 *
 * TODO: Titleist needs to write the ajax call here. Fake sample timer shows results options.
 * I think that you could move this function outside of this file if that helps.
 * Valid ids: t100, t150, t200, t350, 620mb, 620cb
 *
 */
window.submitResultsForm = function (email, primaryId, primaryFIid, loft, shaftMake, shaftModel, shaftFlex) {
	console.log("window.submitResultsForm: " + email + " primaryId: " + primaryId)
	//Put ajax calls here using parameter variable?
	//debugger;
	var xmlhttp = new XMLHttpRequest() // new HttpRequest instance
	xmlhttp.onreadystatechange = function () {
		if (xmlhttp.readyState == 4) {
			if (xmlhttp.responseText != undefined) {
				let responseM = JSON.parse(xmlhttp.responseText)
				if (responseM.success) window.showResultsSuccess()
				else window.showResultsError()
			} else {
				window.showResultsError()
			}
		}
	}
	//debugger;
	xmlhttp.open("POST", resutlsHook);
	var formData = new FormData()
	let terms = document.querySelectorAll("#terms")
	let optin = false

	if (terms && terms[0].checked) {
		optin = true
	}

	var formData = new FormData()
	formData.append("email", email)
	formData.append("products[0][name]", primaryId)
	formData.append("products[0][id]", primaryFIid)
	formData.append("products[0][loft]", loft)
	formData.append("products[0][shaftMake]", shaftMake)
	formData.append("products[0][shaftModel]", shaftModel)
	formData.append("products[0][shaftFlex]", shaftFlex)
	formData.append("optin", optin)
	xmlhttp.send(formData)
	
}
